import { Component, EventEmitter, Output, OnInit, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { AppService, Theme } from 'src/app/service/app.service';
import { ConfigService, IClientConfig } from 'src/app/service/config.service';
import { WebViewInteropService } from 'src/app/service/web-view-interop.service';
import { DialogComponent } from '../dialog.component';

@Component({
    selector: 'app-settings-dialog',
    templateUrl: './settings-dialog.component.html',
    imports: [DialogComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsDialogComponent implements OnInit {
  @Output() closed = new EventEmitter<void>();

  currentTheme: Theme = Theme.Light;
  themeType = Theme;
  config: IClientConfig | undefined;

  constructor(
    private configService: ConfigService,
    private webViewInterop: WebViewInteropService,
    private appService: AppService
  ) {}

  ngOnInit(): void {
    this.currentTheme = this.appService.getTheme();
    this.config = this.configService.getClientConfiguration();
  }

  changeTheme(newTheme: Theme) {
    this.appService.changeTheme(newTheme);
    this.currentTheme = this.appService.getTheme();
  }

  changed(event: any) {
    if (this.config) {
      this.config.zoomFactor = event.target.value;
    }
  }

  changedTray(event: any) {
    if (this.config) {
      this.config.useTrayIcon = event.target.checked;
    }
  }

  saveSetting() {
    if (this.config) {
      this.configService.setClientConfiguration(this.config);
    }
    this.closed.emit();
  }

  openPath(path: string) {
    this.webViewInterop.openLink(path);
  }

  close() {
    this.closed.emit();
  }
}